import {NumberInput, Select, SimpleGrid, TextInput} from '@mantine/core'
import {DateInput} from '@mantine/dates'
import type {UseFormReturnType} from '@mantine/form'

import {toLocalDate} from 'src/jobs/job-schedule-format'

import type {LoadEntryFormValues} from './load-entry-logic'
import type {LoadDriver} from './schemas'

type LoadEntryFieldsProps = {
    form: UseFormReturnType<LoadEntryFormValues>
    drivers?: LoadDriver[]
    allowNoDriver?: boolean
    driverLabel?: string
}

const NO_DRIVER = 'none'

export function LoadEntryFields({
    form,
    drivers,
    allowNoDriver = false,
    driverLabel = 'Driver',
}: LoadEntryFieldsProps) {
    const driverOptions = [
        ...(allowNoDriver ? [{value: NO_DRIVER, label: 'No driver (job total for the day)'}] : []),
        ...(drivers ?? []).map((driver) => ({
            value: driver.assignmentId,
            label: driver.workerName,
        })),
    ]
    return (
        <SimpleGrid cols={{base: 1, sm: 2}} spacing="md">
            {drivers ? (
                <Select
                    label={driverLabel}
                    data={driverOptions}
                    value={form.values.assignmentId ?? (allowNoDriver ? NO_DRIVER : null)}
                    onChange={(value) =>
                        form.setFieldValue(
                            'assignmentId',
                            value && value !== NO_DRIVER ? value : null,
                        )
                    }
                    error={form.errors['assignmentId']}
                    allowDeselect={false}
                    required={!allowNoDriver}
                />
            ) : null}
            <DateInput
                label="Day"
                value={form.values.loadDate}
                onChange={(value) =>
                    form.setFieldValue('loadDate', value == null ? null : toLocalDate(value))
                }
                error={form.errors['loadDate']}
                required
            />
            <NumberInput
                label="Loads hauled"
                min={1}
                allowDecimal={false}
                value={form.values.loadCount ?? ''}
                onChange={(value) =>
                    form.setFieldValue('loadCount', typeof value === 'number' ? value : null)
                }
                error={form.errors['loadCount']}
                required
            />
            <TextInput
                label="Ticket / BOL number"
                placeholder="Optional"
                {...form.getInputProps('ticketNumber')}
            />
        </SimpleGrid>
    )
}
